/* eslint-disable react/react-in-jsx-scope */
import { isArray } from 'lodash'
import { useCallback } from 'react'
import { AutoCompleteDataType, AutoCompleteFormik } from 'scenes/Dashboard/components/Inputs/Select'
import { AutoCompleteProps } from 'scenes/Dashboard/components/Inputs/Select/AutoComplete/AutoComplete.component'
import { SelectOption } from 'scenes/Dashboard/components/Inputs/Select/Common/Select.model'
import { FieldProps } from 'utils-next/forms'

import {
  Feature,
  featureLabelToFeature,
  featureToFeatureLabel,
  FeatureToFeatureLabels,
} from '../../../../../../../../../entities-next/corporate'

export type CorporateFeaturesSelectProps = Omit<
  AutoCompleteProps,
  'value' | 'dataType' | 'onCreateOption' | 'onChange'
> &
  FieldProps

const featureOptions: {
  display: {
    label: string
  }
  value: string
}[] = []

Object.keys(Feature).map((key) => {
  const typedKey = key as keyof typeof FeatureToFeatureLabels
  featureOptions.push({
    display: {
      label: FeatureToFeatureLabels[typedKey],
    },
    value: key,
  })
})

export function CorporateFeaturesSelect(selectProps: CorporateFeaturesSelectProps) {
  const { name, value } = selectProps.field
  const { setFieldValue } = selectProps.form
  const handleChange = useCallback(
    (selectOption: SelectOption | undefined) => {
      if (!selectOption) {
        setFieldValue(name, [])
        return
      }
      if (isArray(selectOption)) {
        const values = selectOption.map((option) => featureLabelToFeature(option.value))
        setFieldValue(name, values)
      }
    },
    [name, setFieldValue]
  )

  const parsedValues = value
    ? value.map((feature: Feature) =>
        feature ? { value: feature, display: { label: featureToFeatureLabel(feature) } } : undefined
      )
    : undefined

  return (
    <AutoCompleteFormik
      dataType={AutoCompleteDataType.feature}
      onChange={handleChange}
      loadOptions={async (value) => {
        return featureOptions.filter((option) => {
          return option.display.label.toLowerCase().includes(value.toLowerCase())
        })
      }}
      isMulti={true}
      getOptionLabel={(option: SelectOption) => option.label}
      getOptionValue={(option: SelectOption) => option.value}
      value={parsedValues}
      placeholder={'Select premium features'}
      {...selectProps}
    />
  )
}
